import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthContextService } from '../services/auth-context.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authContextService = inject(AuthContextService);
  const token = sessionStorage.getItem('token');
  const idToken = sessionStorage.getItem('id_token');
  const isCognitoTokenRequest = req.url.includes('/oauth2/token');

  let cloned = req;

  console.warn('[authInterceptor] hit', {
    method: cloned.method,
    url: cloned.url
  });

  if (authContextService.hasInternalAccess && cloned.url.includes('/dashboard/embedURL')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/dashboard/embedURL', '/internal/dashboard/embedURL')
    });
  }

  if (authContextService.hasInternalAccess && cloned.url.includes('user/s3-presigned')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/user/s3-presigned', '/internal/user/s3-presigned')
    });
  }

  if(authContextService.hasInternalAccess && cloned.url.includes('/user/subscriptions')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/user/subscriptions', '/internal/user/subscriptions')
    });
  }

  if(authContextService.hasInternalAccess && cloned.url.includes('/user/s3Reports')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/user/s3Reports', '/internal/user/s3Reports')
    });
  }

  if (authContextService.hasInternalAccess && cloned.url.includes('/user/settings')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/user/settings', '/internal/user/settings')
    });
  }

  if(authContextService.hasInternalAccess && cloned.url.includes('/report-params')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/report-params', '/internal/report-params')
    });
  }

  if(authContextService.hasInternalAccess && cloned.url.includes('/user/feature-flags')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/user/feature-flags', '/internal/user/feature-flags')
    });
  }

  if(authContextService.hasInternalAccess && cloned.url.includes('/user/guides')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/user/guides', '/internal/user/guides')
    });
  }
  
  if (!isCognitoTokenRequest && (token || idToken)) {
    const headers: Record<string, string> = {};
    if (token) {
      headers['Authorization'] = token;
    }
    if (idToken) {
      headers['id_token'] = idToken;
    }
    cloned = cloned.clone({
      setHeaders: headers
    });
  }

  return next(cloned);
};